import type { ParentedItemKey } from '@onviobr/toolbox-document-services/dist/esm5/models';
import { LegacyDocument } from './file-preview-toolbar-services-facade';

export interface IHeaderButton {
	tooltip: string;
	clickAction: () => void;
	icon: string;
}

export interface IParent {
	id: string;
	type: string;
}

export interface IPermissions {
	canDelete: boolean;
}

export interface IDocument1 {
	id: string;
	name: string;
	parent: IParent;
	mimeType: string;  // can be file extension or actual mimeType
	permissions?: IPermissions; // Required if hideDelete = false
}

export interface IParentItem {
	itemType: string;
}

export interface IDocument2 extends ParentedItemKey {
	id: string;
	name: string;
	containerId: string;
	parentItem: IParentItem;
	mimeType: string;  // can be file extension or actual mimeType
	permissions?: IPermissions; // Required if hideDelete = false
	lock: LegacyLock;
	canPreview: boolean;
	legacyItem: LegacyDocument;
	fileExtension: string;
}

export interface LegacyLock {
	context?: string | undefined;
	contextInfo: Map<string, Record<string, unknown>>;
	createdBy: string;
	createdDate: Date;
	isContainer: boolean;
	level: string;
	resourceRestrictions: Array<any>;
	type: string;
}

export interface IPreviewData {
	documents: (IDocument1 | IDocument2)[];
	currentIndex: number;
	lang: string;
	bookmark?: string;
	customHeaderButtons?: IHeaderButton[];
	downloadUri?: string;
	emitHeaderButtonClicks?: boolean;
	hideBookmarks?: boolean;
	hideClose?: boolean;
	hideDownload?: boolean;
	hideHelp?: boolean;
	hidePrint?: boolean;
	hideDelete?: boolean;
	themeColor?: string;
	usePDF?: boolean;
	parentEl?: HTMLElement;
	initialZoom?: number;
}

export enum DocumentEvent {
	Accessed = 'Accessed',
	Copied = 'Copied',
	Moved = 'Moved',
	Approved = 'Approved',
	Updated = 'Updated',
	OpenedInLink = 'OpenedInLink',
	OpenedInPreview = 'OpenedInPreview',
	Renamed = 'Renamed',
	SentTo = 'SentTo',
	Deleted = 'Deleted',
	Trashed = 'Trashed',
}
